const LOCAL_WEB_API: string = (window as any).LOCAL_WEB_API || '';
const GENERAL_API: string = (window as any).GENERAL_API || '';
const IDENTITY_API: string = (window as any).IDENTITY_API || '';
const DEALER_API: string = (window as any).DEALER_API || '';

export { DEALER_API, GENERAL_API, IDENTITY_API, LOCAL_WEB_API };
